import { render, staticRenderFns } from "./ConclusionDNA.vue?vue&type=template&id=7870ca0e&scoped=true&"
import script from "./ConclusionDNA.vue?vue&type=script&lang=js&"
export * from "./ConclusionDNA.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionDNA.vue?vue&type=style&index=0&id=7870ca0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870ca0e",
  null
  
)

export default component.exports